/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-12 14:16:50
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-09 16:00:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/Components/FileList/config.ts
 */
export const filterConfig = (data, { getI18n }) => [
  {
    type: 'selection',
    name: getI18n('general.type'),
    data: [
      { key: 'Image', name: getI18n('general.tools_helper.image') },
      { key: 'Video', name: getI18n('general.tools_helper.video') },
    ],
  },
  {
    type: 'selection',
    name: getI18n('general.tags'),
    data,
  },
];
export const sortConfig = ({ getI18n }) => [
  {
    name: getI18n('storeFileLibrary.list.filenameAZ'),
    key: 'originalName 1',
  },
  {
    name: getI18n('storeFileLibrary.list.filenameZA'),
    key: 'originalName 0',
  },
  {
    name: getI18n('storeFileLibrary.list.filesizelargest'),
    key: 'size 0',
  },
  {
    name: getI18n('storeFileLibrary.list.filesizesmallest'),
    key: 'size 1',
  },
  {
    name: getI18n('storeFileLibrary.list.uploadedoldest'),
    key: 'createdDate 1',
  },
  {
    name: getI18n('storeFileLibrary.list.uploadednewest'),
    key: 'createdDate 0',
  },
];
